import React from "react";
import {useAppSelector} from "../../../../app/hooks";
import {mainColourSelector} from "../../../chatbotSlice";

interface Props {
    openDetails?: () => void;
    handleLinkClick: (e: any) => void;
}

export const OpenDetailsButton: React.FC<Props> = ({ handleLinkClick, openDetails }) => {
    const mainColour = useAppSelector(mainColourSelector);

    const getButtonTitle = (): string => {
        return !!openDetails ? "Open details" : "Tell me more"
    }

    return <button
        onClick={(e) => handleLinkClick(e)}
        className="group flex flex-row justify-between items-center py-3 px-6 font-semibold text-base rounded-b-2xl w-full text-white"
        style={{ backgroundColor: mainColour }}
    >
        {getButtonTitle()}
        <div className="flex flex-row items-center">
            <img
                id="open-gallery-icon"
                itemProp="open gallery icon"
                alt="Open gallery icon"
                src="/gallery-icon-arrow.svg"
                className="w-4 h-4 text-white transition-transform duration-300 delay-75 group-hover:translate-x-2"
                width="16"
                height="16"
            />
        </div>
    </button>
}
